import { LoadingOutlined } from '@ant-design/icons'
import { Flex, Row, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import dashboardApi from '../../api/dashboard.api'
import { userState } from '../../store/user'
import '../../styles/home.scss'

const ReviewDashboard = () => {
  const navigate = useNavigate()
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false) //임시
  const [reviewCount, setReviewCount] = useState({
    week: 0,
    high: 0,
    low: 0,
  })

  useEffect(() => {
    getReview()
  }, [])

  const getReview = async () => {
    let param = {
      userId: user.id,
    }
    const res = await dashboardApi.readReview(param)
    if (res.data.code === 200) {
      setReviewCount({
        week: res.data.result.weekScore,
        high: res.data.result.highScore,
        low: res.data.result.lowScore,
      })
    }
  }

  const listTitle = (key) => {
    if (key === 'week') {
      return '새로 작성된 리뷰'
    } else if (key === 'high') {
      return '평점 높은 리뷰'
    } else if (key === 'low') {
      return '평점 낮은 리뷰'
    }
  }

  return (
    <Flex
      vertical
      style={{ minWidth: '280px', height: '100%', flex: 1 }}
      className={`home-dashboard-component dash-cursor ${isLoading ? 'container-disable' : ''}`}
      onClick={() => navigate('/review/list')}
    >
      {isLoading && (
        <Spin
          className={'home-dashboard-loading'}
          indicator={<LoadingOutlined spin />}
          size={'large'}
        />
      )}
      <Flex align={'center'} gap={4} className={'home-dashboard-title'}>
        <h2>리뷰</h2>
        <p className={'title-info-text'}>최근 일주일 기준</p>
      </Flex>
      <Flex
        vertical
        justify={'start'}
        gap={20}
        className={'inquiry-list-wrap'}
        style={{ paddingBottom: '16px' }}
      >
        {Object.keys(reviewCount).map((key, idx) => (
          <Row
            key={`inquiry-list-${idx}`}
            className={'inquiry-list-div'}
            style={{ justifyContent: 'space-between', display: 'flex' }}
          >
            <p>{listTitle(key)}</p>
            <div className={'inquiry-list-count-div'}>
              <p>{reviewCount[key]?.toLocaleString()} 건</p>
            </div>
          </Row>
        ))}
      </Flex>
    </Flex>
  )
}

export default ReviewDashboard
